import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getInvestmentInvestors, getInvestmentProgression, getInvestmentTasks } from '../../../redux/actions/investments';
import ContributionsInvestment from '../ContributionsInvestment/ContributionsInvestment';
import InvestmentResume from '../InvestmentResume/InvestmentResume';
import InvestorsInInvestment from '../InvestorsInInvestment/InvestorsInInvestment';
import './InvestmentDetails.scss';

const TABS = [
  { id: 'resume', label: 'Resumo' },
  { id: 'investors', label: 'Investidores' },
  { id: 'contributions', label: 'Aportes' },
];

const InvestmentDetails = ({ investment, handleClose, setShowModal, edit, investmentTasks, topic }) => {
  const [activeTab, setActiveTab] = useState('resume');
  const dispatch = useDispatch();
  const investmentDetails = useSelector(state => state.investmentDetails);

  // Suporta dois formatos: { topic: { id } } (tabela) ou { id } (métricas flat)
  const topicId = topic ? (investment?.topic?.id ?? investment?.id) : investment?.id;
  const topicName = topic ? (investment?.topic?.name ?? investment?.name) : investment?.name;
  const topicSymbol = topic ? (investment?.topic?.symbol ?? investment?.symbol) : investment?.symbol;

  useEffect(() => {
    if (!topicId) return;
    dispatch(getInvestmentProgression(topicId));
    dispatch(getInvestmentInvestors(topicId));
    dispatch(getInvestmentTasks({ topicId }));
  }, [topicId, dispatch]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  return createPortal(
    <div className="id-overlay">
      <div className="id-backdrop" onClick={handleClose} />
      <div className="id-modal">

        <div className="id-header">
          <div className="id-header-info">
            <span className="id-label">Investimento</span>
            <div className="id-title-row">
              {topicSymbol && <span className="id-symbol">{topicSymbol}</span>}
              <h2 className="id-title">{topicName}</h2>
            </div>
          </div>
          <button className="id-close" onClick={handleClose}>
            <X size={18} />
          </button>
        </div>

        <div className="id-tabs">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`id-tab${activeTab === tab.id ? ' id-tab--active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="id-body">
          {activeTab === 'resume' && (
            <InvestmentResume
              topic={topic}
              topicId={topicId}
              investment={investment}
              investmentDetails={investmentDetails}
              investmentTasks={investmentTasks}
              setShowModal={setShowModal}
              edit={edit}
            />
          )}
          {activeTab === 'investors' && (
            <InvestorsInInvestment investmentDetails={investmentDetails} />
          )}
          {activeTab === 'contributions' && (
            <ContributionsInvestment investmentDetails={investmentDetails} />
          )}
        </div>

      </div>
    </div>,
    document.body
  );
};

export default InvestmentDetails;
